// English Translations - AI Financial Tools Positioning
const en = {
  // Common
  common: {
    calculate: 'Calculate',
    copy: 'Copy',
    download: 'Download',
    compare: 'Compare',
    reset: 'Reset',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    year: 'year',
    years: 'years',
    month: 'month',
    months: 'months',
    currency: 'IDR',
    percent: '%',
    required: 'Required',
    invalid: 'Invalid',
    success: 'Success',
    error: 'An error occurred',
    loading: 'Loading...',
    relatedCalculators: 'Related Calculators',
    viewAll: 'View All'
  },
  
  // Navigation
  nav: {
    home: 'Home',
    calculators: 'Calculators',
    kpr: 'Mortgage',
    investment: 'Investment',
    emergencyFund: 'Emergency Fund',
    aiBudget: 'AI Budget',
    insurance: 'Insurance',
    blog: 'Blog',
    admin: 'Admin'
  },
  
  // Homepage - AI Financial Tools Positioning
  home: {
    title: 'Free AI-Powered Financial Planning Tools',
    subtitle: 'Smart mortgage simulation, investment calculator, emergency fund planner, and AI budget assistant.',
    heroTitle: 'Smart Financial Planning with AI',
    heroSubtitle: 'Indonesia\'s most comprehensive AI financial tools platform',
    ctaButton: 'Get Started',
    features: {
      title: 'Key Features',
      kpr: 'Intelligent mortgage comparison with staged interest',
      investment: 'AI-powered investment growth simulator',
      emergency: 'Smart emergency fund calculator',
      ai: 'AI Budget Planner with personalized advice'
    }
  },
  
  // KPR Calculator
  kpr: {
    title: 'Mortgage Calculator',
    subtitle: 'Intelligent Home Loan Simulation',
    description: 'Calculate your mortgage payments with staged interest rates, flexible down payment, and up to 30-year tenure.',
    propertyPrice: 'Property Price',
    downPayment: 'Down Payment',
    tenor: 'Total Tenure',
    interestRate: 'Interest Rate',
    fixedPeriod: 'Fixed Period',
    floatingRate: 'Floating Rate',
    monthlyPayment: 'Monthly Payment',
    totalPayment: 'Total Payment',
    totalInterest: 'Total Interest',
    loanAmount: 'Loan Amount',
    calculateButton: 'Calculate Mortgage',
    compareButton: 'Compare Scenarios',
    stages: 'Interest Stages',
    fixedStage: 'Fixed Stage',
    floatingStage: 'Floating',
    duration: 'Duration',
    remaining: 'remaining auto',
    tips: {
      title: 'Mortgage Tips',
      tip1: 'Compare total interest, not just promotional rates',
      tip2: 'Prepare for payment increase during floating period',
      tip3: 'Consider early repayment options',
      tip4: 'Keep monthly payment under 30% of income'
    }
  },
  
  // Investment Calculator
  investment: {
    title: 'Investment Calculator',
    subtitle: 'AI-Powered Return Simulation',
    description: 'Simulate investment growth with various instruments and AI-powered risk profiling.',
    initialAmount: 'Initial Investment',
    monthlyContribution: 'Monthly Contribution',
    annualReturn: 'Annual Return',
    investmentPeriod: 'Investment Period',
    finalValue: 'Final Value',
    totalInvested: 'Total Invested',
    totalReturn: 'Total Return',
    calculateButton: 'Calculate Investment',
    simpleMode: 'Simple',
    advancedMode: 'Advanced',
    aiRecommendation: 'Use AI Recommendation',
    instruments: {
      deposito: 'Time Deposit',
      obligasi: 'Bonds',
      reksadana_pasar_uang: 'Money Market Fund',
      reksadana_pendapatan_tetap: 'Fixed Income Fund',
      reksadana_campuran: 'Balanced Fund',
      reksadana_saham: 'Equity Fund',
      saham: 'Stocks',
      emas: 'Gold',
      crypto: 'Crypto'
    },
    tips: {
      title: 'Investment Tips',
      tip1: 'Start investing as early as possible',
      tip2: 'Consistently add monthly contributions',
      tip3: 'Diversify your portfolio',
      tip4: 'Choose instruments matching your risk profile'
    }
  },
  
  // Emergency Fund Calculator
  emergencyFund: {
    title: 'Emergency Fund Calculator',
    subtitle: 'Smart Financial Safety Net Planner',
    description: 'Calculate your ideal emergency fund based on your monthly expenses and lifestyle.',
    monthlyExpenses: 'Monthly Expenses',
    monthlyDebt: 'Monthly Debt Payments',
    dependents: 'Number of Dependents',
    employmentType: 'Employment Type',
    existingFund: 'Current Emergency Fund',
    targetFund: 'Target Emergency Fund',
    monthlyTarget: 'Monthly Savings Target',
    timeToGoal: 'Time to Goal',
    calculateButton: 'Calculate Emergency Fund Plan',
    employmentTypes: {
      employee: 'Employee',
      freelancer: 'Freelancer',
      business_owner: 'Business Owner'
    },
    tips: {
      title: 'Emergency Fund Tips',
      tip1: 'Keep it in a separate account',
      tip2: 'Choose liquid instruments',
      tip3: 'Don\'t use for risky investments',
      tip4: 'Review needs every 6 months',
      tip5: 'Automate transfers after payday'
    }
  },
  
  // AI Budget Planner
  aiBudget: {
    title: 'AI Budget Planner',
    subtitle: 'Intelligent Financial Planning',
    description: 'Let AI create a personalized monthly budget based on your financial profile.',
    monthlyIncome: 'Monthly Income',
    city: 'City',
    rentMortgage: 'Rent/Mortgage',
    existingDebt: 'Debt Payments',
    generateButton: 'Generate AI Budget',
    recommendation: 'AI Recommendation',
    allocation: 'Budget Allocation',
    tips: {
      title: 'Budget Tips',
      tip1: 'Prioritize essential needs',
      tip2: 'Save at least 20% of income',
      tip3: 'Review budget monthly',
      tip4: 'Use digital envelope system'
    }
  },
  
  // Insurance Calculator
  insurance: {
    title: 'Life Insurance Calculator',
    subtitle: 'Smart Protection Coverage Estimator',
    description: 'Estimate your ideal life insurance coverage to protect your family.',
    age: 'Current Age',
    annualIncome: 'Annual Income',
    dependents: 'Number of Dependents',
    existingDebt: 'Existing Debt',
    coverageAmount: 'Coverage Amount',
    termSuggestion: 'Suggested Term',
    premiumEstimate: 'Estimated Monthly Premium',
    calculateButton: 'Calculate Insurance Needs',
    tips: {
      title: 'Insurance Tips',
      tip1: 'Choose term life for pure protection',
      tip2: 'Read policy carefully',
      tip3: 'Select reputable companies',
      tip4: 'Review needs every 3-5 years'
    }
  },
  
  // Lead Capture
  leadCapture: {
    title: 'Enter Your Details',
    subtitle: 'to continue',
    name: 'Full Name',
    email: 'Email',
    phone: 'Phone Number',
    noSpam: 'Don\'t worry, we won\'t spam you.',
    copyNow: 'Copy Now',
    downloadNow: 'Download Now',
    processing: 'Processing...',
    successMessage: 'Data saved successfully!'
  },
  
  // Footer
  footer: {
    description: 'Indonesia\'s most comprehensive AI-powered financial planning platform.',
    calculators: 'Calculators',
    resources: 'Resources',
    company: 'Company',
    about: 'About Us',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    copyright: '© 2025 KalkulatorDuit. All rights reserved.',
    poweredBy: 'Powered by Wealthify'
  },
  
  // SEO Content - AI Financial Tools Focus
  seo: {
    kpr: {
      title: 'Intelligent Mortgage Calculator Guide',
      intro: 'Making smart home loan decisions requires accurate calculations. Our AI-powered mortgage calculator helps you compare scenarios and plan for interest rate changes.',
      howItWorks: 'How Our Smart Calculator Works',
      howItWorksDesc: 'Our mortgage calculator uses advanced algorithms to simulate monthly payments with staged interest rates (fixed and floating periods).',
      whyUse: 'Why Use Our AI Mortgage Tool?',
      benefits: [
        'Accurate simulation with staged interest rates',
        'Compare different down payment scenarios',
        'Prepare for floating rate adjustments',
        'Download results for bank comparison'
      ],
      faq: [
        { q: 'What\'s the ideal down payment?', a: 'Ideally 20-30% of property price. Higher down payment means lower monthly payments.' },
        { q: 'What\'s the difference between fixed and floating rates?', a: 'Fixed rates stay constant for a period, while floating rates follow market conditions.' },
        { q: 'What\'s the maximum loan tenure?', a: 'Generally 20-25 years, depending on age and bank policies.' }
      ]
    },
    investment: {
      title: 'AI-Powered Investment Calculator Guide',
      intro: 'Growing your wealth requires smart planning. Our AI investment calculator helps you project returns and build a risk-appropriate portfolio.',
      howItWorks: 'Understanding Compound Growth',
      howItWorksDesc: 'Compound interest works by reinvesting your returns, so your gains generate additional gains over time.',
      whyUse: 'Benefits of AI Investment Simulation',
      benefits: [
        'Realistic projections with historical returns',
        'Compare various investment instruments',
        'Understand the impact of regular contributions',
        'Set long-term financial goals'
      ],
      faq: [
        { q: 'What\'s a realistic investment return?', a: 'Deposits 4-6%, money market 5-7%, stocks 10-15% annually (historical).' },
        { q: 'When\'s the best time to start investing?', a: 'Now! The earlier you start, the greater the compound interest benefit.' },
        { q: 'Is investing safe?', a: 'Every investment has risks. Choose instruments matching your risk profile.' }
      ]
    },
    emergencyFund: {
      title: 'Smart Emergency Fund Planning Guide',
      intro: 'An emergency fund provides financial security during unexpected events like job loss or medical emergencies.',
      howItWorks: 'How We Calculate Your Target',
      howItWorksDesc: 'Emergency fund size is calculated based on monthly expenses multiplied by the recommended coverage months.',
      whyUse: 'Why Emergency Funds Matter',
      benefits: [
        'Protection from unexpected events',
        'Avoid debt during emergencies',
        'Financial peace of mind',
        'Solid foundation for financial planning'
      ],
      faq: [
        { q: 'How much emergency fund do I need?', a: '6 months expenses for employees, 9-12 months for freelancers or business owners.' },
        { q: 'Where should I keep my emergency fund?', a: 'Savings account or deposits that are easily accessible.' },
        { q: 'Can I invest my emergency fund?', a: 'Not recommended. Emergency funds should be liquid and safe.' }
      ]
    },
    aiBudget: {
      title: 'AI Budget Planner Guide',
      intro: 'AI Budget Planner helps you create a smart and personalized monthly financial plan.',
      howItWorks: 'How AI Budget Planner Works',
      howItWorksDesc: 'AI analyzes your income, mandatory expenses, and financial goals to provide optimal budget allocation recommendations.',
      whyUse: 'Benefits of AI-Powered Budgeting',
      benefits: [
        'Personalized budget recommendations',
        'Adjusts to your city\'s cost of living',
        'Savings and investment optimization',
        'Easy-to-follow suggestions'
      ],
      faq: [
        { q: 'What is the 50/30/20 method?', a: 'Popular method: 50% needs, 30% wants, 20% savings/investments. AI adjusts based on your situation.' },
        { q: 'How do I start budgeting?', a: 'Track all your monthly income and expenses, then use AI Budget Planner for personalized recommendations.' },
        { q: 'Are AI results accurate?', a: 'AI provides recommendations based on financial best practices, customized to the data you provide.' }
      ]
    },
    insurance: {
      title: 'Life Insurance Calculator Guide',
      intro: 'Life insurance provides financial protection for your family in case of unexpected events.',
      howItWorks: 'How We Calculate Insurance Needs',
      howItWorksDesc: 'Insurance needs are calculated based on annual income, number of dependents, and outstanding debts.',
      whyUse: 'Why Life Insurance Matters',
      benefits: [
        'Protect your family from financial risks',
        'Coverage that fits your needs',
        'Good estate planning',
        'Peace of mind'
      ],
      faq: [
        { q: 'How much insurance coverage do I need?', a: 'Typically 5-10x annual income, depending on dependents and debts.' },
        { q: 'When should I buy life insurance?', a: 'The younger the better - premiums are lower and rejection risk is smaller.' },
        { q: 'What\'s the difference between term and whole life insurance?', a: 'Term provides coverage for a specific period (cheaper), whole life provides lifetime coverage.' }
      ]
    }
  },

  // SEO Content Blocks for each page (800-1200 characters)
  seoContent: {
    home: {
      title: 'AI-Powered Financial Planning Tools',
      content: 'KalkulatorDuit offers free AI-powered financial planning tools designed for smart money management. Our intelligent calculators help you make data-driven decisions about mortgages, investments, and budgeting. With advanced AI algorithms, we analyze your financial profile to provide personalized recommendations. Whether you\'re planning to buy a home, grow your investments, or build an emergency fund, our smart tools guide you every step. Join thousands of users who trust KalkulatorDuit for intelligent financial planning.'
    },
    kpr: {
      title: 'Smart Mortgage Comparison Tool',
      content: 'Our AI-powered mortgage calculator goes beyond basic calculations. It intelligently simulates staged interest rates, comparing fixed and floating periods to give you accurate payment projections. The smart comparison feature helps you analyze multiple scenarios side-by-side, identifying the most cost-effective option. Perfect for first-time homebuyers and property investors looking to make informed decisions. Get instant insights on total interest costs and monthly payment variations throughout your loan tenure.'
    },
    investment: {
      title: 'AI Investment Growth Simulator',
      content: 'Experience intelligent investment planning with our AI-powered calculator. Our advanced algorithms simulate compound growth across various instruments including stocks, mutual funds, and bonds. The built-in AI risk profiler analyzes your financial goals and risk tolerance to recommend optimal portfolio allocations. Visualize your wealth growth trajectory and make smarter investment decisions. Perfect for both beginners learning about compounding and experienced investors optimizing their portfolios.'
    },
    emergencyFund: {
      title: 'Intelligent Emergency Fund Planner',
      content: 'Our smart emergency fund calculator considers your unique situation to recommend the ideal safety net. The AI analyzes your employment type, dependents, and monthly expenses to calculate personalized coverage targets. Track your progress with visual indicators and get actionable savings plans. Whether you\'re an employee, freelancer, or business owner, our intelligent tool ensures you\'re prepared for financial uncertainties. Build your financial resilience with data-driven planning.'
    },
    aiBudget: {
      title: 'AI-Powered Budget Planning Assistant',
      content: 'Let artificial intelligence transform your budgeting. Our AI Budget Planner analyzes your income, expenses, and financial goals to create personalized spending recommendations. The intelligent system considers your city\'s cost of living and suggests optimal allocation across needs, wants, and savings. Get real-time financial health indicators and actionable advice. Stop guessing about your budget - let AI guide you toward financial wellness with smart, personalized recommendations.'
    },
    insurance: {
      title: 'Smart Insurance Coverage Calculator',
      content: 'Determine your ideal life insurance coverage with our intelligent calculator. The AI considers your income, dependents, and existing debts to recommend appropriate protection levels. Our smart tool helps you understand the financial impact on your family and suggests optimal coverage terms. Compare premium estimates and make informed decisions about protecting your loved ones. Get personalized insurance insights without the complexity of traditional calculators.'
    }
  },

  // Metadata for SEO
  meta: {
    home: {
      title: 'Free Financial Calculator + AI Finance Tools | KalkulatorDuit',
      description: 'Free financial calculators for mortgage, investment, monthly budget simulation, and AI tools that help you make smarter financial decisions.'
    },
    kpr: {
      title: 'AI Mortgage Calculator - Smart Home Loan Simulation | KalkulatorDuit',
      description: 'Calculate mortgage payments with AI-powered staged interest simulation. Compare scenarios, plan for floating rates, and make intelligent home buying decisions.'
    },
    investment: {
      title: 'AI Investment Calculator - Smart Portfolio Growth Simulator | KalkulatorDuit',
      description: 'Simulate investment growth with AI risk profiling. Calculate compound returns, compare instruments, and get personalized portfolio recommendations.'
    },
    emergencyFund: {
      title: 'Smart Emergency Fund Calculator - AI Financial Safety Planner | KalkulatorDuit',
      description: 'Calculate your ideal emergency fund with AI-powered analysis. Personalized targets based on employment type, expenses, and dependents.'
    },
    aiBudget: {
      title: 'AI Budget Planner - Intelligent Financial Planning Assistant | KalkulatorDuit',
      description: 'Create personalized budgets with AI. Smart allocation recommendations, real-time financial health indicators, and actionable savings advice.'
    },
    insurance: {
      title: 'Smart Life Insurance Calculator - AI Coverage Estimator | KalkulatorDuit',
      description: 'Estimate ideal life insurance coverage with AI analysis. Personalized recommendations based on income, dependents, and financial goals.'
    }
  }
};

export default en;
